/*
 * Copyright 2026 Bytefinger Technology (HK) Co., Limited (https://bytefinger.ai)
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { type ContentType } from '@adp-common/chat-core';

import { type Message } from '../store/types';

export const mergeAckIntoUserMessage = <T extends ContentType>(
  userMessage: Message<T>,
  ackMessage: Message<ContentType>,
): Message<T> => ({
  ...userMessage,
  message_id: ackMessage.message_id || userMessage.message_id,
  reply_id: ackMessage.reply_id || userMessage.reply_id,
  section_id: ackMessage.section_id || userMessage.section_id,
  content_time: ackMessage.content_time ?? userMessage.content_time,
  is_finish: true,
  logId: ackMessage.logId ?? userMessage.logId,
  extra_info: {
    ...userMessage.extra_info,
    ...ackMessage.extra_info,
    local_message_id:
      ackMessage.extra_info?.local_message_id ||
      userMessage.extra_info.local_message_id,
  },
});
